import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from '../plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

if (!window.origin) {
  window.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
}

window.getAPIURL = function () {
  if (debug) {
    return 'http://explore-data-world.test/'
  } else {
    if (checkProd()) {
      return 'https://api.explore.data.world/'
    } else {
      return 'http://api.explore-data-world.treetop.us/'
    }
  }
}

window.getStaticAssetURL = function () {
  if (debug) {
    return 'http://equote30.test/'
  } else {
    if (checkProd()) {
      return 'https://api.explore.data.world/'
    } else {
      return 'http://api.explore-data-world.treetop.us/'
    }
  }
}

function checkProd() {
  return (window.origin === 'http://explore.data.world' || window.origin === 'https://explore.data.world')
}

const API_BASE = 'api/'

export const API_URL = window.getAPIURL()

export const FEATURED_DATASETS = API_URL + API_BASE + 'featured-datasets'
export const RECENT_INTEGRATIONS = API_URL + API_BASE + 'recent-integrations'
export const TAG_CLOUD = API_URL + API_BASE + 'tag-cloud'
export const RECENT_DATA_PARTNERS = API_URL + API_BASE + 'recent-data-partners'
export const DATASETS_POPULAR = API_URL + API_BASE + 'datasets-popular'
export const DATASETS_NEW = API_URL + API_BASE + 'datasets-new'
export const DATASETS_RISING = API_URL + API_BASE + 'datasets-rising'
export const USERS_POPULAR = API_URL + API_BASE + 'users-popular'
export const USERS_NEW = API_URL + API_BASE + 'users-new'
export const USERS_RISING = API_URL + API_BASE + 'users-rising'

export default new Vuex.Store({
  modules: {
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js